const VIEWPORT_META =
  '<meta name="viewport" content="width=device-width, initial-scale=1">';

const BASE_STYLE = `<style>
  html, body { margin: 0; padding: 0; }
  img, video, canvas, svg { max-width: 100%; height: auto; }
</style>`;

export function buildSrcDoc(html: string): string {
  const source = html.trim();
  if (!source) {
    return `<!DOCTYPE html><html><head>${VIEWPORT_META}${BASE_STYLE}</head><body></body></html>`;
  }

  if (/<html[\s>]/i.test(source)) {
    let doc = source;
    if (!/<meta[^>]+viewport/i.test(doc)) {
      if (/<head[\s>]/i.test(doc)) {
        doc = doc.replace(/<head([^>]*)>/i, `<head$1>${VIEWPORT_META}`);
      } else {
        doc = doc.replace(/<html([^>]*)>/i, `<html$1><head>${VIEWPORT_META}</head>`);
      }
    }
    if (!/<meta[^>]+charset/i.test(doc) && /<head[\s>]/i.test(doc)) {
      doc = doc.replace(/<head([^>]*)>/i, `<head$1><meta charset="utf-8">`);
    }
    return doc;
  }

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  ${VIEWPORT_META}
  ${BASE_STYLE}
</head>
<body>
${source}
</body>
</html>`;
}

export function applySrcDoc(iframe: HTMLIFrameElement, srcdoc: string): void {
  iframe.setAttribute("sandbox", "allow-scripts allow-forms");
  iframe.setAttribute("loading", "lazy");
  iframe.setAttribute("tabindex", "-1");
  iframe.setAttribute("title", "Device preview");
  if (iframe.getAttribute("data-srcdoc") !== srcdoc) {
    const card = iframe.closest<HTMLElement>(".hdp-device");
    card?.classList.add("is-loading");
    card?.setAttribute("aria-busy", "true");
    iframe.onload = () => {
      card?.classList.remove("is-loading");
      card?.setAttribute("aria-busy", "false");
    };
    iframe.setAttribute("data-srcdoc", srcdoc);
    iframe.srcdoc = srcdoc;
  }
}

export function debounce<T extends (...args: never[]) => void>(
  fn: T,
  wait: number,
): T {
  let timer = 0;
  const wrapped = ((...args: never[]) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => fn(...args), wait);
  }) as T;
  return wrapped;
}
